import React from 'react';
import { DatePicker } from 'antd';
import './index.scss'
import moment from "moment/moment";
export default class WWDatePicker extends React.Component{
    constructor(props) {
        super(props);
    }
    render () {
        const {value,onChange, ...otherProps} = this.props;
        let temp = value;
        temp && (temp.toString().length === 10) ?temp = temp*1000:""
        temp = temp?moment(temp): null
        return (
            <DatePicker value ={temp} style={{height:30}} onChange={(date)=>{
                onChange(moment(date).unix());
            }} {...otherProps}/>
        )
    }
}